import React, { useState, useCallback, useEffect } from 'react';

const AnalysisResizeHandle = ({ resizeHandle, showStatus, setShowStatus, searchContainerRef, setResized }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0); // 開始時のマウスのX座標
    const [startWidth, setStartWidth] = useState(0); // 開始時の幅
    const [showCloseLeftTooltip, setShowCloseLeftTooltip] = useState(false);
    const [showCloseRightTooltip, setShowCloseRightTooltip] = useState(false);
    const [leftTooltipMessage, setLeftTooltipMessage] = useState('');
    const [rightTooltipMessage, setRightTooltipMessage] = useState('');

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const handleMouseDown = useCallback((e) => {
        e.preventDefault();
        setIsResizing(true);
        setStartX(e.clientX); // マウスの開始X座標を設定
        setStartWidth(searchContainerRef.current.getBoundingClientRect().width);
    }, []);

    const handleMouseMove = useCallback((e) => {
      if (isResizing) {
        setResized(true);
          const newWidth = startWidth + (e.clientX - startX); // 新しい幅を計算
          resizeHandle(newWidth); // 親コンポーネントに新しい幅を渡す
      }
    }, [isResizing, startX, startWidth, resizeHandle]);

    const handleMouseUp = useCallback(() => {
        setIsResizing(false);
    }, []);

    // マウス移動とリリースのグローバルイベントリスナーを追加
    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, handleMouseMove, handleMouseUp]);

    const clickLeft = () => {
        // statusを見て判断
        // 右側が表示されていれば左側を閉じる、右側が表示されていなければ右側を開く
        if (showStatus !== 'left') // 右側が表示されている状態
            setShowStatus('right');
        else if (showStatus === 'left') { // 右側が表示されていない状態 
            setShowStatus('both');
        }
        setShowCloseLeftTooltip(false);
    }

    const clickRight = () => {
        // statusを見て判断
        // 左側が表示されていれば右側を閉じる、右側が表示されていなければ右側を開く
        if (showStatus !== 'right') // 左側が表示されている状態
            setShowStatus('left');
        else if (showStatus === 'right') { // 左側が表示されていない状態 
            setShowStatus('both');
        }
        setShowCloseRightTooltip(false);
    }

    useEffect(() => {
        if (showStatus === 'both') {
            setLeftTooltipMessage('検索画面を閉じる');
            setRightTooltipMessage('分析画面を閉じる');
        } else if (showStatus === 'left') {
            setLeftTooltipMessage('分析画面を開く');
        } else if (showStatus === 'right') {
            setRightTooltipMessage('検索画面を開く');
        }
    }, [showStatus])

    return (
        <div className="analysis-handle">
            {/* 真ん中のハンドル */}
            {showStatus === 'both' &&
                <div
                    className="analysis-resize-handle"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onMouseDown={handleMouseDown}
                > 
                    {showTooltip && <span className="dashboard-resize-handle-tooltip">幅を変える</span>}
                </div>
            }
            
            {/* 左側の矢印(ハンドル) : 右だけ表示(status="right"となっていなければ表示 */}
            {showStatus !== 'right' && 
                <div 
                    className='close-left' 
                    onClick={clickLeft}
                    onMouseEnter={() => setShowCloseLeftTooltip(true)}
                    onMouseLeave={() => setShowCloseLeftTooltip(false)}
                    >
                    <i className="fa-solid fa-chevron-left"></i>
                </div>
            }
            {showCloseLeftTooltip && <span className="close-left-tooltip">{leftTooltipMessage}</span>}
            
            {/* 右側の矢印(ハンドル) : 右だけ表示(status="right"となっていなければ表示 */}
            {showStatus !== 'left' && 
                <div 
                    className='close-right' 
                    onClick={clickRight}
                    onMouseEnter={() => setShowCloseRightTooltip(true)}
                        onMouseLeave={() => setShowCloseRightTooltip(false)}
                        >
                    <i className="fa-solid fa-chevron-right"></i>
                </div>      
              }
            {showCloseRightTooltip && <span className="close-right-tooltip">{rightTooltipMessage}</span>}
        </div>
    );
};

export default AnalysisResizeHandle;
